import { render } from "./LegoSwapUnit.vue?vue&type=template&id=97d3db1e"
import script from "./LegoSwapUnit.vue?vue&type=script&lang=js"
export * from "./LegoSwapUnit.vue?vue&type=script&lang=js"
script.render = render

export default script